export default __webpack_public_path__ + "static/slide1-9bca1c8ae0c72b1c6e2f753c13f53b07.jpg";